import { Partytown } from '@builder.io/partytown/react';

function PartyTownComponent() {
  return <Partytown forward={['dataLayer.push']} />;
}

export default PartyTownComponent;
